import { createGlobalStyle } from "styled-components";

const LocalStyles = createGlobalStyle`
  * {
      font-family: Arial, Helvetica, sans-serif
  }
`;

export default LocalStyles;
